import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './AdminApp';
import reportWebVitals from './reportWebVitals';
import { setupApiInterceptors } from './utils/setupApiInterceptors';

const isAdminBuild = process.env.REACT_APP_BUILD_TARGET === 'admin';

// Portal only: redirect to login on expired/invalid session (admin has its own auth flow).
if (!isAdminBuild) setupApiInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdminBuild ? <AdminApp /> : <App />}
  </React.StrictMode>
);

reportWebVitals();
